import styled from '@emotion/styled'
import { observer } from 'mobx-react-lite'
import { FC } from 'react'
import { useRussianPokerContext } from '../../providers/RussianPokerProvider'
import { topBarIconHoverStyles } from '../Icons/styles'
import { ExitIcon } from '../index'

const StyledExitIcon = styled(ExitIcon)`
  ${topBarIconHoverStyles}
`

const StyledLink = styled.a`
  display: flex;
  position: relative;

  /* Увеличенная область клика для мобильных устройств */
  &::after {
    content: '';
    position: absolute;
    top: -12px;
    left: -12px;
    right: -12px;
    bottom: -12px;
  }
`

export const LogoutBtn: FC = observer(() => {
  const { forceLeaveGame } = useRussianPokerContext()

  return (
    <StyledLink
      href="#"
      id="logoutBtn"
      data-cy="rp-logout-btn"
      onClick={async (e) => {
        e.preventDefault()
        e.stopPropagation()

        forceLeaveGame()
      }}>
      <StyledExitIcon
        color="white"
        size={{
          mobile: '13px',
          tablet: '22px',
          desktop: '22px',
        }}
      />
    </StyledLink>
  )
})
